import Middleware from '../Middleware';
import { runInAction } from 'mobx';
import { EventTypes } from '../../events';

var timerMiddleware = function timerMiddleware(now) {
  var timers = new Map();
  return Middleware(function (evt) {
    switch (evt.type) {
      case EventTypes.NAVIGATION_START:
        {
          var started = now();
          timers.set(evt.navigation.sequence, started);
          evt.elapsed = 0;
          return evt;
        }

      case EventTypes.NAVIGATION_CANCELLED:
      case EventTypes.NAVIGATION_END:
        {
          var navigation = evt.navigation;

          if (navigation) {
            var _started = timers.get(navigation.sequence);

            timers.delete(navigation.sequence);

            if (typeof _started === 'number') {
              evt.elapsed = now() - _started;
            }
          }

          return evt;
        }

      default:
        {
          var _navigation = evt.navigation;

          if (_navigation) {
            var _started2 = timers.get(_navigation.sequence);

            if (typeof _started2 === 'number') {
              evt.elapsed = now() - _started2;
            }
          }

          return evt;
        }
    }
  });
};

export default timerMiddleware;